const parsePrice = (price: string) => {
  const symbolMatch = price.match(/[^0-9\s,.]+/);
  const symbol = symbolMatch ? symbolMatch[0] : '';
  const numeric = price.replace(symbol, '').trim();
  return { numeric, symbol };
};
const formatPriceSuffix = (price: string) => {
  const { numeric, symbol } = parsePrice(price);
  return (
    <>
      <span>{numeric}</span>
      <span>&nbsp;{symbol}</span>
      <span className="price-small">*</span>
    </>
  );
};
const formatPriceSuffixStrike = (price: string, stricken = false) => {
  const { numeric, symbol } = parsePrice(price);
  return (
    <>
      <span className={stricken ? 'strike' : ''}>{numeric}</span>
      <span>&nbsp;{symbol}</span>
    </>
  );
};
interface Props {
  priceNoFormat: number;
  avpNoFormat: number;
  prescriptionRequired: number;
  avpFormatted: string;
  priceFormatted: string;
}
export const ProductPrice = (props: Props) => {
  return (
    <div className="product-card__price">
      {/* Price */}
      <div
        className="product-card__price--red"
        role="group"
        aria-label={
          props.prescriptionRequired === 1
            ? props.avpFormatted
            : props.priceFormatted
        }
      >
        <div aria-hidden="true">
          {props.prescriptionRequired === 1
            ? formatPriceSuffix(props.avpFormatted)
            : formatPriceSuffix(props.priceFormatted)}
        </div>
      </div>

      {/* UVP */}
      {props.priceNoFormat < props.avpNoFormat &&
        props.prescriptionRequired === 0 && (
          <div
            className="product-card__price--uvp"
            role="group"
            aria-label={props.avpFormatted}
          >
            <div aria-hidden="true">
              {formatPriceSuffixStrike(props.avpFormatted, true)}
            </div>
          </div>
        )}
    </div>
  );
};